import { Routes } from '@angular/router';

import { SignComponent } from './sign/sign.component';
import { ForgotComponent } from './forgot/forgot.component';
import { ChangePasswordComponent } from './change-password/change-password.component';

import { LoginComponent } from './login.component';

export const LoginRoutes: Routes = [{
    path: 'login',
    component: LoginComponent,
    children: [{
        path: '',
        redirectTo: 'sign',
        pathMatch: 'full'
    }, {
        path: 'sign',
        component: SignComponent
    }, {
        path: 'forgot',
        component: ForgotComponent
    }, {
        path: 'change-pass/:id',
        component: ChangePasswordComponent
    }]
}];